import { array, boolean, defineAction, enumerated, number, object, string } from '~/prix'
import {
  googleMapsInteractionFields,
  googlePlacesPresentationFields,
  googlePlacesStatus,
} from './searchAddressGoogle.contract'
import appSebraeSearchAddressAction from './appSebraeSearchAddress.action.json' with { type: 'json' }

const appSebraeSearchAddressDefinition = defineAction({
  ...appSebraeSearchAddressAction,
  operation: 'read' as const,
  userActivityLog: true,
  input: object({
    ...googleMapsInteractionFields,
    address: string().label('Endereço parcial a ser pesquisado.'),
    number: string().isOptional().label('Número do endereço.'),
    latitude: number().isOptional().label('Latitude usada para resolver ou desempatar resultados.'),
    longitude: number()
      .isOptional()
      .label('Longitude usada para resolver ou desempatar resultados.'),
    limit: number().isOptional().label('Número máximo de resultados retornados.'),
  }),
  output: object({
    googleStatus: googlePlacesStatus.isOptional(),
    preferredSource: string().isOptional(),
    warnings: array(
      object({
        message: string(),
      }),
    ).isOptional(),
    results: array(
      object({
        source: enumerated({ prix: 'prix', google_places: 'google_places' }).isOptional(),
        displayAddress: string(),
        requiresResolution: boolean().isOptional(),
        streetId: number().isOptional(),
        streetName: string().isOptional(),
        number: string().isOptional(),
        neighborhoodId: number().isOptional(),
        neighborhoodName: string().isOptional(),
        cityId: number().isOptional(),
        cityName: string().isOptional(),
        stateId: number().isOptional(),
        stateAbbreviation: string().isOptional(),
        latitude: number().isOptional(),
        longitude: number().isOptional(),
        quality: string().isOptional(),
        placeId: string().isOptional(),
        mainText: string().isOptional(),
        secondaryText: string().isOptional(),
        types: array(string()).isOptional(),
        attributions: googlePlacesPresentationFields.attributions.isOptional(),
        presentation: googlePlacesPresentationFields.presentation.isOptional(),
      }),
    ),
  }),
})

export default appSebraeSearchAddressDefinition
